import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import VideoModal from "../../components/ModalVideo";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from "../../img/slider-1.jpg";
import hero2 from "../../img/slider-2.png";

import "./style.css";
 
class Hero extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  render() {
    var settings = {
      dots: false,
      arrows: true,
      speed: 1600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2600,
      fade: true,
    };

    return (
      <section className="hero-area">
        <div className="hero-social">
          <ul>
            <li>
              <a href="https://www.facebook.com/SanitariosDelCentro/"> 
                <i className="fab fa-facebook-f" /> 
              </a>
            </li>

            <li>
              <a href="https://wa.me/+524772632080"> 
                <i className="fa fa-phone" />
              </a>
            </li>

            <li>
              <a href="mailto:ventas@wccompany.com.mx"> 
                <i className="fa fa-envelope" />
              </a>
            </li>

          </ul>
          <p>Síguenos</p>
        </div>

        <div className="hero-slider">
          <div className="hero_arrows">
            <button className="button" onClick={this.previous}>
              <i className="fas fa-angle-left"></i>
            </button>
            <button className="button" onClick={this.next}>
              <i className="fas fa-angle-right"></i>
            </button>
          </div>
          <Slider ref={(c) => (this.slider = c)} {...settings}>
            <div className="slide">
              <div
                className="hero-slide-item"
                style={{ backgroundImage: `url(${hero1})` }}
              >
                <div className="container">
                  <div className="hero-text">
                    <h2>
                      Renta de <br />
                      sanitarios
                    </h2>
                    <div className="hero-action">
                      <Link to="/service" className="cta-btn btn-fill">
                      Ver más
                      </Link>
                      <Link to="/contact" className="cta-btn btn-border">
                          Contáctanos
                      </Link>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
            <div className="slide">
              <div
                className="hero-slide-item"
                style={{ backgroundImage: `url(${hero2})` }}
              >
                <div className="container">
                <div className="hero-text">
                    <h2>
                      Renta de <br />
                      sanitarios
                    </h2>
                    <div className="hero-action">
                      <Link to="/service" className="cta-btn btn-fill">
                      Ver más
                      </Link>
                      <Link to="/contact" className="cta-btn btn-border">
                        Contáctanos
                      </Link>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </section>
    );
  }
}

export default Hero;
